import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { InputProps, inputStyle } from "Shared/Form/Input";
import styled from "styled-components";
import { isUS as isAccountUS } from "src/utils/account";
import { AccountState } from "Types/state";
import CAPostalCode from "src/components/CustomizePayment/ZipCode/CAPostalCode";
import USZipCode from "src/components/CustomizePayment/ZipCode/USZipCode";

interface PostalCodeRowProps {
    account?: AccountState;
    onChange: (e: any, isUS: boolean) => void;
    onFocus?: () => void;
    value?: string;
    zipCodeSource: string;
    region: string;
    hideCalculatorRow?: boolean;
}

class CreditAppZipCode extends Component<PostalCodeRowProps & WithTranslation> {
    public render() {
        const { region, t, zipCodeSource, value, onChange, ...rest } = this.props;
        const isUS: boolean = isAccountUS(region);

        return isUS ? (
            <USZipCode locationType={zipCodeSource} value={value || ""} onChange={this.update(isUS)} {...rest} />
        ) : (
            <CAPostalCode
                locationType={zipCodeSource}
                value={value || ""}
                onBlur={this.update(isUS)}
                onChange={this.update(isUS)}
                {...rest}
            />
        );
    }

    private update = (isUS: boolean) => (e: { target: { value: string } }) => {
        this.props.onChange(e, isUS);
    };
}

export default styled(withTranslation()(CreditAppZipCode))<InputProps>`
    font-weight: normal;
    margin: 5px 0;
    max-width: unset;
    ${inputStyle};
    padding: 16px 0;

    input {
        padding: 0 0 0 3px;
    }

    ${(props) => props.theme.breakpoints.up("desktop")} {
        padding: 16px 0 16px 10px;
    }
`;
